import rules from "../../Data/Rules"
import store from "../../veux/store";
import functions from "../../Data/Functions"
import { createToastInterface } from "vue-toastification";
import axios from "axios";

const Server = process.env.VUE_APP_HOST_SERVER || "https://server.ownurgoal.net.au"
let Testing
let submitStatus = "NO"
// let Testing = (Server === "https://server.ownurgoal.net.au") ? false : true;

const toast_options = {
    // You can set your default toast options here
    timeout: 2000,
    position: "bottom-center",
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
};

// Create Toast the interface
const toast = createToastInterface(toast_options);

let Countries = [
    { code: "AU", detail: "Australia" },
    { code: "NZ", detail: "New Zealand" },
    { code: "UK", detail: "United Kingdom" },
    { code: "US", detail: "United States" },
]


let Months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]

let Years = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033]

// Pay Step Schema
let Pay_Step = (step, heading) => {
    return {
        stepno: step,
        title: 'Payment',
        nextBtn: "NO",
        valid: true,
        information: `${heading}`,
        Schema: {
            ProductDesc: {
                type: 'text',
                label: "Product",
                outlined: true,
                dense: true,
                hidden: false,
                disabled: true,
                // col: 12,
                class: 'mx-1 px-1',
                toCtrl: ({ data }) => { return data.ProductDesc },
            },
            Amount: {
                type: 'text',
                label: "Amount",
                outlined: true,
                dense: true,
                hidden: false,
                disabled: true,
                // col: 12,
                // mask: "$ #####.##",
                class: 'mx-1 px-1 align-end',
                toCtrl: ({ data }) => { return data.Amount },
            },
            cardHolder: {
                type: 'text',
                label: "Card Holder's Name",
                outlined: true,
                dense: true,
                hidden: false,
                // col: 12,
                rules: [rules.requiredMsg("Card Holder's Name is Required")],
                class: 'mx-1 px-1',
                onInput: (ev, portal) => {
                    ev.data.cardHolder = functions.capitalizeFirstLetter(ev.data.cardHolder).trim();
                }
            },
            cardNumber: {
                type: 'text',
                label: "Card Number",
                outlined: true,
                dense: true,
                hidden: false,
                // col: 12,
                mask: "#### #### #### ####",
                rules: [rules.requiredMsg("Card Number is Required")],
                class: 'mx-1 px-1',
                // onInput: (ev, portal) => { }
            },
            expMonth: {
                type: 'select',
                label: "Expiry Month",
                outlined: true,
                dense: true,
                hidden: false,
                items: Months,
                // col: 4,
                rules: [rules.requiredMsg("Expiry Month is Required")],
                class: 'mx-1 px-1',
                // onInput: (ev, portal) => { }
            },
            expYear: {
                type: 'select',
                label: "Expiry Year",
                outlined: true,
                dense: true,
                hidden: false,
                items: Years,
                // col: 4,
                rules: [rules.requiredMsg("Expiry Year is Required")],
                class: 'mx-1 px-1',
                // onInput: (ev, portal) => { }
            },
            CVC: {
                type: 'text',
                label: "Card CVC",
                outlined: true,
                dense: true,
                hidden: false,
                // col: 4,
                rules: [rules.requiredMsg("CVC is Required")],
                class: 'mx-1 px-1',
                // onInput: (ev, portal) => { }
            },
            email: {
                type: 'email',
                label: 'Email Address',
                outlined: true,
                dense: true,
                // col: 12,
                rules: [rules.validEmail, rules.requiredMsg('Email is Required')],
                class: 'mx-1 px-1',
                prependInnerIcon: 'alternate_email',
                toCtrl: ({ data }) => { return data.email },
                OUG: { Contact_Details: { Type: 3, Action: "Unique" } }
            },
            address: {
                type: 'text',
                label: 'Address',
                outlined: true,
                dense: true,
                prependInnerIcon: 'home',
                rules: [rules.requiredMsg('Address is Required')],
                // col: 12,
                class: 'mx-1 px-1',
                onInput: (ev, portal) => { },
                toCtrl: ({ data }) => { return data.address }
            },
            city: {
                type: 'text',
                label: 'City',
                outlined: true,
                dense: true,
                rules: [rules.requiredMsg('City is Required')],
                class: 'mx-1 px-1',
                // col: 6,
                onInput: (ev, portal) => { },
                toCtrl: ({ data }) => { return data.city }
            },
            state: {
                type: 'text',
                label: 'State / Province / Region',
                outlined: true,
                dense: true,
                rules: [rules.requiredMsg('State / Province / Region is Required')],
                class: 'mx-1 px-1',
                // col: 3,
                onInput: (ev, portal) => { },
                toCtrl: ({ data }) => { return data.state }
            },
            pcode: {
                type: 'text',
                label: 'Postal / Zip Code',
                outlined: true,
                dense: true,
                rules: [rules.requiredMsg('Postal / Zip Code is Required')],
                class: 'mx-1 px-1',
                // col: 3,
                onInput: (ev, portal) => { },
                toCtrl: ({ data }) => { return data.pcode }
            },
            Country: {
                type: "select",
                label: 'Please select a Country: ',
                outlined: true,
                row: true,
                dense: true,
                hidden: false,
                // col: 12,
                rules: [rules.requiredMsg('Country Selection is Required')],
                class: 'mx-1 px-1',
                items: Countries,
                returnObject: true,
                itemText: 'detail',
                // onInput: (ev, portal) => { }
            },
            Paytoken: {
                type: 'text',
                label: 'Pay Token',
                hidden: true,
            },
            ValidatePayment: {
                type: "btn",
                block: true,
                rounded: true,
                color: "orange",
                col: { cols: 12, sm: 6, md: 6, lg: 6, xl: 6 },
                label: 'Process Payment',
                iconRight: 'check',
                class: 'mx-0 px-10',
                onClick: (val, home) => {
                    let { data, schema, obj } = val
                    if (home.$refs.stepForm[home.currentStep - 1].validate()) {
                        home.data.Model.Contact_id = (store.getters.currentUser) ? store.getters.currentUser.Contact_id : 0
                        return new Promise((resolve, reject) => {
                            let payment = {
                                amount: Number(data.Amount) * 100,
                                description: data.ProductDesc,
                                email: data.email,
                                card: {
                                    number: Number(data.cardNumber.replace(/ /g, "")),
                                    expiry_month: data.expMonth,
                                    expiry_year: Number(data.expYear),
                                    cvc: data.CVC,
                                    name: data.cardHolder,
                                    address_line1: data.address,
                                    address_city: data.city,
                                    address_postcode: data.pcode,
                                    address_state: data.state,
                                    address_country: data.Country.code
                                }
                            }
                            let payload = {
                                Contact_id: (store.getters.currentUser) ? store.getters.currentUser.Contact_id : 0
                            }
                            const toastId = toast.info(`Payment being Processed - Please Wait!`, {
                                timeout: false, closeButton: false,
                            });
                            let baseURL = ''
                            if (Testing) {
                                baseURL = `${Server}/pin/Test_Payment`; //"https://server.ownurgoal.net.au/pin/Test_Payment";
                            } else {
                                baseURL = `${Server}/pin/Payment`;  //"https://server.ownurgoal.net.au/pin/Payment";
                            }
                            // Process PIN Payment
                            axios
                                .post(baseURL, payment)
                                .then(async (response) => {
                                    home.data.Model.Paytoken = response.data.payload.token
                                    await functions.getData(`INSERT INTO Payments (Contact_id, Product_id, Description, Reference, Amount, Method) 
                                        VALUES(${data.Contact_id}, ${data.team.id}, '${data.ProductDesc}', '${response.data.payload.token}', ${data.Amount}, 'PinPay');`, false);
                                    toast.dismiss(toastId);
                                    toast.success(`Payment Successfull - Please Finalise Registration`, {
                                        timeout: 1000,
                                    });
                                    home.validateStepForm(home.currentStep - 1)
                                    resolve()
                                })
                                .catch((error) => {
                                    if (error) {
                                        let err_message = "";
                                        switch (error.response.data.data.error) {
                                            case "card_declined":
                                            case "insufficient_funds":
                                            case "invalid_cvv":
                                            case "invalid_card":
                                            case "processing_error":
                                            case "suspected_fraud":
                                            case "gateway_error":
                                            case "unknown":
                                                err_message = error.response.data.data.error_description;
                                                break;
                                            case "invalid_resource":
                                                switch (error.response.data.data.messages[0].code) {
                                                    case "card_expiry_month_invalid":
                                                        err_message = "Card's expiry is in the past";
                                                        break;
                                                    case "card_cvc_invalid":
                                                        err_message = error.response.data.data.messages[0].message;
                                                        break;
                                                    default:
                                                        err_message = "Unknown Error with this Card";
                                                        break;
                                                }
                                                break;
                                            default:
                                                err_message = "Unknown Error with this Card"
                                                break;
                                        }
                                        toast.dismiss(toastId);
                                        toast.error(`Payment Failed: ${err_message}`, {
                                            timeout: 6000,
                                        });
                                        reject()
                                    }
                                });
                        })
                    }
                }
            }
        },
        PreStep: (thisStep, portal) => {

            let { Model, Schema } = thisStep


            if (Number(Model.Amount) === 0) {
                thisStep.nextBtn = "YES"
                Schema.cardHolder.hidden = true
                Schema.cardHolder.rules = []
                Schema.cardNumber.hidden = true
                Schema.cardNumber.rules = []
                Schema.expMonth.hidden = true
                Schema.expMonth.rules = []
                Schema.expYear.hidden = true
                Schema.expYear.rules = []
                Schema.CVC.hidden = true
                Schema.CVC.rules = []
                Schema.email.hidden = true
                Schema.email.rules = []
                Schema.address.hidden = true
                Schema.address.rules = []
                Schema.city.hidden = true
                Schema.city.rules = []
                Schema.state.hidden = true
                Schema.state.rules = []
                Schema.pcode.hidden = true
                Schema.pcode.rules = []
                Schema.Country.hidden = true
                Schema.Country.rules = []
                Schema.ValidatePayment.hidden = true
            } else {
                thisStep.nextBtn = "NO"
                Schema.cardHolder.hidden = false
                Schema.cardHolder.rules = [rules.requiredMsg("Card Holder's Name is Required")]
                Schema.cardNumber.hidden = false
                Schema.cardNumber.rules = [rules.requiredMsg("Card Number is Required")]
                Schema.expMonth.hidden = false
                Schema.expMonth.rules = [rules.requiredMsg("Expiry Month is Required")]
                Schema.expYear.hidden = false
                Schema.expYear.rules = [rules.requiredMsg("Expiry Year is Required")]
                Schema.CVC.hidden = false
                Schema.CVC.rules = [rules.requiredMsg("CVC is Required")]
                Schema.email.hidden = false
                Schema.email.rules = [rules.requiredMsg("Email is Required")]
                Schema.address.hidden = false
                Schema.address.rules = [rules.requiredMsg("Address is Required")]
                Schema.city.hidden = false
                Schema.city.rules = [rules.requiredMsg("City is Required")]
                Schema.state.hidden = false
                Schema.state.rules = [rules.requiredMsg("State is Required")]
                Schema.pcode.hidden = false
                Schema.pcode.rules = [rules.requiredMsg("Post Code is Required")]
                Schema.Country.hidden = false
                Schema.Country.rules = [rules.requiredMsg("Country is Required")]
                Schema.ValidatePayment.hidden = false
            }

            if (Testing) {
                Model.cardHolder = "Fred Smith"
                Model.cardNumber = "4200 0000 0000 0000"
                Model.expMonth = 10
                Model.expYear = 2029
                Model.CVC = "345"
                Model.email = "tkyle@awbnet.net"
                Model.address = "17 Highgrove Street"
                Model.city = "Thornlands"
                Model.state = "QLD"
                Model.pcode = "4156"
            }
        },
    }
}

export default {

    LoadSchema: async (Step, Parameters) => {
        let heading
        if (Parameters.Testing === 'true' || Server != "https://server.ownurgoal.net.au") {
            Testing = true
            heading = `<h3 class="d-flex flex-column justify-space-between align-center" style="color: red">
                Testing Card Payments Only !
            </h3>`
        } else {
            Testing = false
            heading = `<h3 class="d-flex flex-column justify-space-between align-center" style="color: red">
                Visa and Master Card Payments Only !
            </h3>`
        }
        return Pay_Step(Step, heading)
    },

}